import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../Auths/CheckUser";

const SewaClientContractTable = () => {

  const {user} = useAuth()

  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedZone, setSelectedZone] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get(`https://globizsystems.click/api/user/${user.id}`);
        setClients(res.data.clients);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to fetch client data", "error");
      }
    };
    fetchClients();
  }, [user?.id]);

  const filteredClients = selectedZone
    ? clients.filter((c) => c.zoneId === selectedZone)
    : [];

  const totalPayment = filteredClients.reduce(
    (sum, c) => sum + (Number(c.arrears) || 0),
    0
  );

  return (
      <div className="  mt-3 mx-3">
      

        {/*  Zone Selection Dropdown */}
        <div className="mb-6 max-w-sm mx-auto">
          <label className="block font-semibold mb-2 text-gray-800">
            Pilih Customer
          </label>
          <select
            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={selectedZone}
            onChange={(e) => setSelectedZone(e.target.value)}
          >
            <option value="">Select Zone</option>
            <option value="2">Zone 2</option>
            <option value="4">Zone 4</option>
          </select>
        </div>

        {/*  Show Data Based on Selected Zone */}
        {selectedZone && (
          <div className="mb-6 bg-white rounded-lg shadow-md  border border-gray-200">
            <h2 className="font-semibold text-base md:text-lg mb-3">
              Zon {selectedZone} — Jumlah Tunggakan:{" "}
              <span className="font-bold text-blue-600">
                RM {totalPayment.toLocaleString()}
              </span>
            </h2>

            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse text-sm md:text-base">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="p-2 text-left font-semibold">Gambar</th>
                    <th className="p-2 text-left font-semibold">Tarikh</th>
                    <th className="p-2 text-left font-semibold">Jenis</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClients.length > 0 ? (
                    filteredClients.map((client) => (
                      <tr
                        key={client.id}
                        onClick={() => setSelectedClient(client)}
                        className="border-b hover:bg-gray-50 cursor-pointer"
                      >
                        <td className="p-2">
                          {client.contractImage ? (
                            <img
                              src={`https://globizsystems.click${client.contractImage}`}
                              alt="Contract"
                              className="w-12 h-12 md:w-16 md:h-16 object-cover rounded-md border"
                            />
                          ) : (
                            <span className="text-gray-400 text-xs">
                              No Image
                            </span>
                          )}
                        </td>
                        <td className="p-2">
                          {client.contractStartDate
                            ? new Date(
                                client.contractStartDate
                              ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td className="p-2">{client.contractType || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        className="text-center text-gray-500 py-3 text-sm"
                      >
                        Tiada data untuk Zon {selectedZone}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Popup Modal */}
        {selectedClient && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-2">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl p-6 relative overflow-y-auto max-h-[90vh]">
              <button
                onClick={() => setSelectedClient(null)}
                className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded-full hover:bg-red-600"
              >
                <FontAwesomeIcon icon={faClose} />
              </button>
              <h2 className="text-xl font-bold mb-4 text-center">
                Butiran Penuh Klien
              </h2>

              <div className="space-y-2 text-sm md:text-base">
                {Object.entries(selectedClient).map(([key, value]) => (
                  <p key={key}>
                    <span className="font-semibold capitalize">{key}:</span>{" "}
                    {key === "contractImage" && value ? (
                      <img
                        src={`https://globizsystems.click${value}`}
                        alt="Contract"
                        className="w-32 h-32 object-cover rounded-md border mt-1"
                      />
                    ) : (
                      <span className="text-gray-700">
                        {String(value) || "—"}
                      </span>
                    )}
                  </p>
                ))}
              </div>

              {/*  Update Button */}
              <div className="text-center mt-6">
                <button
                  onClick={() =>
                    navigate(`/update-contract/${selectedClient.id}`)
                  }
                  className="bg-blue-600 text-white px-5 py-2 rounded-md hover:bg-blue-700"
                >
                  Update Contract
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
  );
};

export default SewaClientContractTable;
